import { useSubscription } from "@/provider/SubscriptionProvider";

export function TrialCountdown() {
  const { status, trialEndDate } = useSubscription();

  if (status !== "trial" || trialEndDate === null) {
    return null;
  }

  const daysLeft = Math.ceil(
    (new Date(trialEndDate).getTime() - Date.now()) / (1000 * 60 * 60 * 24),
  );
  const totalDays = 30; // Assuming 30 day trial
  const progress =
    ((totalDays - (daysLeft >= 0 ? daysLeft : 0)) / totalDays) * 100;
  const isUrgent = daysLeft <= 7;
  const isCritical = daysLeft <= 3;

  const ringColor = isCritical
    ? "text-destructive"
    : isUrgent
      ? "text-warning"
      : "text-primary";

  const bgColor = isCritical
    ? "bg-destructive/8"
    : isUrgent
      ? "bg-warning/8"
      : "bg-primary/8";

  const strokeColor = isCritical
    ? "hsl(var(--destructive))"
    : isUrgent
      ? "hsl(var(--warning))"
      : "hsl(var(--primary))";

  const circumference = 2 * Math.PI * 14;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div
      className={`inline-flex min-h-10 max-w-full items-center gap-2 rounded-full border border-border bg-background px-2.5 py-1.5 shadow-sm sm:min-h-11 sm:gap-3 sm:px-3 sm:py-2 ${bgColor}`}
    >
      <div className="relative h-7 w-7 shrink-0 sm:h-8 sm:w-8">
        <svg className="h-7 w-7 -rotate-90 sm:h-8 sm:w-8" viewBox="0 0 36 36">
          <circle
            cx="18"
            cy="18"
            r="14"
            fill="none"
            stroke="hsl(var(--muted))"
            strokeWidth="3"
          />
          <circle
            cx="18"
            cy="18"
            r="14"
            fill="none"
            stroke={strokeColor}
            strokeWidth="3"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            className="transition-all duration-500"
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className={`text-[8px] font-bold sm:text-[9px] ${ringColor}`}>
            {daysLeft >= 0 ? daysLeft : 0}
          </span>
        </div>
      </div>
      <div className="min-w-0 flex-1 leading-none sm:flex-none">
        <span
          className={`block whitespace-nowrap text-xs font-semibold sm:text-sm ${ringColor}`}
        >
          {daysLeft >= 0 ? daysLeft : 0} day{daysLeft !== 1 ? "s" : ""} left
        </span>
        <span className="hidden pt-0.5 text-[11px] text-muted-foreground sm:block">
          in trial
        </span>
      </div>
    </div>
  );
}
